import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import bubble from "../../assets/images/menu/disney/bubble-xl.webp";
import bubbleWeb from "../../assets/images/menu/disneyWeb/bubble-xl.svg";
import Text from "../../components/ui/Text";
import Touchable from "../../components/ui/Touchable";
import { MenuTypeMapping } from "../../services/EventTracking/mapping";
import useEventTracking from "../../services/EventTracking/useEventTracking";
import cn from "../../utils/cn";
import { MenuItemType } from "../../types";
import { menuItemData, menuItemStyles, DisneyCharacter } from "./constants";

export default function MenuItem({
  name,
  className,
  delay,
  setSelectedMenuItem,
  setShowDisneyMenu,
  isWeb,
}: {
  name: DisneyCharacter;
  className?: string;
  delay: string;
  setSelectedMenuItem: Dispatch<SetStateAction<MenuItemType>>;
  setShowDisneyMenu: Dispatch<SetStateAction<boolean | null>>;
  isWeb?: boolean;
}) {
  const { t } = useTranslation();

  const mutation = useEventTracking();

  const { type, image, icon } = menuItemData[name];
  const bubbleImage = isWeb ? bubbleWeb : bubble;
  const { bubbleWidth, charactorWidth, fontSize, iconSize } = menuItemStyles;

  if (type === null) throw new Error("Type should not be null in MenuItem");

  const handleMenuClick = () => {
    mutation.mutate({
      pageId: "Disney Menu",
      eventId: MenuTypeMapping[type],
    });

    setSelectedMenuItem(type);
    setShowDisneyMenu(false);
  };

  return (
    <div
      className={cn(
        "disney-menu-slide-in flex flex-col items-center justify-center bg-cover p-3",
        bubbleWidth,
        className,
      )}
      style={{
        backgroundImage: `url(${bubbleImage})`,
        animationDelay: delay,
      }}
      onClick={handleMenuClick}
    >
      <Touchable>
        <img src={image} alt="disney character" className={charactorWidth} />

        <div className="flex items-center justify-center gap-1 whitespace-nowrap">
          <Text className={cn(fontSize, "font-medium")}>{t(type)}</Text>

          {icon ? <img src={icon} alt="icon" className={iconSize} /> : null}
        </div>
      </Touchable>
    </div>
  );
}
